import React, { useState } from 'react';
import CustomerDetail from 'containers/Common/Customer/customerDetail';
import ChiTietHopDongContainer from 'containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2';
import ChiTietHopDongApi from "service/chiTietHopDongApi";
import { ModalChiTietHopDong } from "../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong";

export const BtnChiTietKhachHang = ({ item }) => {
    const [showCustomerDetail, setShowCustomerDetail] = useState(false);
    const [showChoVay, setShowChoVay] = useState(false);
    const [dataChoVay, setDataChoVay] = useState(null);
    const [showNhanVay, setShowNhanVay] = useState(false);
    const [dataNhanVay, setDataNhanVay] = useState(null);

    const handleOpenHopDong = (itemGiaoDich) => () => {
        const dbName = item.DBName;
        if (itemGiaoDich.NhanVayId && itemGiaoDich.NhanVayId > 0) {
            setDataNhanVay(itemGiaoDich);
            setShowNhanVay(true);
            setShowCustomerDetail(false);
            return;
        }

        const choVayId = itemGiaoDich.ChoVayId || itemGiaoDich.ChoVayID;
        if (choVayId) {
            ChiTietHopDongApi.getChiTietHopDong1(choVayId, dbName).then((res) => {
                if (res && res.data) {
                    setDataChoVay(res.data);
                    setShowChoVay(true);
                    setShowCustomerDetail(false);
                }
            });
        }
    };

    return (
        <>
            <a href="#!" onClick={() => setShowCustomerDetail(true)} className="blue btn-link">
                { item.FullName }
            </a>
            {showCustomerDetail && (
                <CustomerDetail
                    show={showCustomerDetail}
                    onHide={() => setShowCustomerDetail(false)}
                    data={{ CustomerID: item.CustomerId || item.CustomerID }}
                    dbName={item.DBName}
                    showChiTietHopDong={handleOpenHopDong} 
                />
            )}
            {showChoVay && dataChoVay && (
                <ChiTietHopDongContainer
                    show={showChoVay}
                    onHide={() => {
                        setShowChoVay(false);
                        setShowCustomerDetail(true);
                    }}
                    data={dataChoVay}
                    dbName={item.DBName}
                    setModalTaiSan={() => { }}
                />
            )}
            {showNhanVay && (
                <ModalChiTietHopDong
                    show={showNhanVay}
                    onHide={() => {
                        setShowNhanVay(false);
                        setShowCustomerDetail(true);
                    }}
                    nhanvayId={dataNhanVay?.NhanVayId}
                    item={dataNhanVay}
                />
            )}
        </>
    );
};